
<template>
  <base-modal :title="title" :width="width" :visible="visible" @cancel="open(false)">
    <div slot="modalBody">
      <a-form :form="form" @submit="handleSubmit">
        <!-- <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="父节点">
          <a-input
            disabled
            autocomplete="off"
            v-decorator="['pName']"
          />
        </a-form-item> -->
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="角色名" hasFeedback>
          <a-input
            placeholder="请输入角色名"
            :disabled="!isEdit"
            autocomplete="off"
            v-decorator="['name', { rules: [{ required: true, message: '请输入角色名！' }, {
              pattern: /^[^\s]*$/, message: '角色名称不能包含空格！' }, {
              max: 50, message: '最多可输入50个字符' }] }]"
          />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="角色编号" hasFeedback>
          <a-input
            placeholder="请输入角色编号"
            :disabled="!isEdit"
            autocomplete="off"
            v-decorator="['code', { rules: [{ required: true, message: '请输入角色编号！' }, {
              pattern: /^[^\s]*$/, message: '角色编号不能包含空格！' }, {
              max: 50, message: '最多可输入50个字符' }, {
              validator: this.checkCode, message: this.helpWords }] }]"
          />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="是否取消部门条件限制" class="radioDiv">
          <a-radio-group v-decorator="['deptAstrict', { rules: [{ required: true, message: '请选择是否取消部门条件限制！' }] }]">
            <a-radio :value="true">
              是
            </a-radio>
            <a-radio :value="false">
              否
            </a-radio>
          </a-radio-group>
          <span class="hint" v-if="form.getFieldValue('deptAstrict')">{{ promptText_True }}</span>
          <span class="hint" v-if="!form.getFieldValue('deptAstrict')">{{ promptText_False }}</span>
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="备注">
          <a-textarea
            placeholder="请输入备注"
            :autosize="{ minRows: 2, maxRows: 4 }"
            :disabled="!isEdit"
            autocomplete="off"
            v-decorator="['remark', { rules: [{ required: false, message: '请输入备注！' }, {
              pattern: /^[^\s]*$/, message: '备注不能包含空格！' }, {
              max: 255, message: '最多可输入255个字符' }] }]"
          />
        </a-form-item>

        <a-form-item :wrapper-col="{ span: 12, offset: 5 }" v-if="isEdit">
          <a-button type="primary" html-type="submit" style="margin-right:10px;">提交</a-button>
          <a-button style="margin-right:10px;" @click="cancel">取消</a-button>
        </a-form-item>
      </a-form>
    </div>
  </base-modal>
</template>

<script>
import baseModal from '@/CrComponents/Modal/Modal.vue'
import { insertRole, updateRole, checkRoleCode } from '@/api/roleList'
export default {
  name: 'EditRole',
  mounted () {},
  computed: {
    isEdit () {
      return this.type !== this.$sysInfo.MODAL_VIEW
    }
  },
  components: {
    baseModal
  },
  data () {
    return {
      title: '操作',
      width: 600,
      type: 'add', //  弹窗的类型： add:新增 |modify:修改 | del:删除
      infoLoading: false, // 编辑窗口，获取详情loading
      form: this.$form.createForm(this, { name: 'role' }),
      visible: false,
      defaultModel: {},
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      validateStatus: '',
      helpWords: '',
      promptText_True: '资产查询的条件不在受使用部门和归口部门的限制；但会受所属公司的的限制',
      promptText_False: '资产数据存在没有使用部门和归口部门的情况，取消部门限制可以查看该情况的资产数据',
    }
  },
  methods: {
    // 设置类型
    setType (type) {
      this.type = type
    },
    // 设置标题
    setTitle (title) {
      this.title = title
    },
    // 设置model 参数 修改时传入
    setModel (model) {
      this.model = Object.assign({}, model)
    },
    // 打开or关闭，修改的窗口先获取详情
    open (flag) {
      this.formClear()
      this.visible = flag
      if (flag) {
        // this.$nextTick(() => {
        //   if () {
        //     this.form.setFieldsValue({
        //       deptAstrict: false
        //     })
        //   }
        // })
        this.getModelInfo(this.model)
      }
    },
    // 校验角色唯一性
    checkCode (rule, value, callback) {
      const checkParams = {
        id: this.model.id ? this.model.id : '',
        code: value
      }
      checkRoleCode(checkParams).then(res => {
        if (!res.data) {
          callback(res.info.message)
        } else {
          callback()
        }
      })
    },
    // 提交表单
    handleSubmit (e) {
      e.preventDefault()
      this.form.validateFieldsAndScroll((err, value) => {
        if (!err) {
          const params = { ...this.model, ...value }
          if (this.type === this.$sysInfo.MODAL_ADD) {
            // 新增角色
            insertRole(params).then(res => {
              if (res.status === 0) {
                this.$message.success(res.info.message)
                this.$emit('updateList')
                this.open(false)
              } else {
                this.$message.error(res.info.message)
              }
            })
          } else if (this.type === this.$sysInfo.MODAL_MODIFY) {
            // 修改角色
            const query = {
              id: params.id,
              pid: params.pid,
              name: params.name,
              code: params.code,
              remark: params.remark,
              deptAstrict: params.deptAstrict
            }
            updateRole(query).then(res => {
              if (res.status === 0) {
                this.$message.success(res.info.message)
                this.$emit('updateList')
                this.open(false)
              } else {
                this.$message.error(res.info.message)
              }
            })
          }
        }
      })
    },
    // 获取当前的model详情
    getModelInfo () {
      this.infoLoading = true
      this.$nextTick(() => {
        this.form.setFieldsValue({
          pName: this.model.pName,
          name: this.model.name,
          code: this.model.code,
          remark: this.model.remark,
          deptAstrict: this.type === this.$sysInfo.MODAL_ADD ? false : this.model.deptAstrict
        })
      })
      this.infoLoading = false
    },
    handleChange () {},
    // 清空表单
    formClear () {
      this.form.resetFields()
    },
    cancel () {
      this.formClear()
      this.open(false)
    }
    // 获取select列表
  }
}
</script>

<style scoped lang="less">
.radioDiv {
  /deep/.ant-form-item-children {
    display: flex;
    align-items: center;
    .ant-radio-group {
      width: 110px;
    }
  }
  .hint {
    width: calc(100% - 110px);
    line-height: 2;
    height: 40px;
    color: red;
  }
}
</style>
